import { motion } from 'framer-motion';
import { FiCode, FiDatabase, FiLayout, FiSettings } from 'react-icons/fi';
import SectionHeading from './SectionHeading';
import { SiteConfig } from '../types/portfolio';
import Icon from './Icon';

type SkillsSectionProps = {
  skills: SiteConfig['skills'];
};

const iconMap = [FiCode, FiLayout, FiSettings, FiDatabase];

function SkillsSection({ skills }: SkillsSectionProps) {
  return (
    <section id="skills" className="section-shell">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionHeading
          eyebrow="Skills"
          title="Broad technical coverage across backend systems, UI engineering, and delivery tooling."
          description="Grouped to reflect the way senior enterprise engineers operate: backend first, frontend aware, platform capable, and delivery focused."
        />

        <div className="grid gap-6 md:grid-cols-2">
          {skills.map((group, index) => {
            const SkillIcon = iconMap[index] || FiCode;

            return (
              <motion.article
                key={group.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                className="glass-panel rounded-[2rem] p-8"
              >
                <div className="flex items-center gap-3 text-sky-200">
                  <Icon icon={SkillIcon} />
                  <h3 className="text-xl font-semibold text-white">{group.title}</h3>
                </div>
                <p className="mt-4 text-sm leading-7 text-slate-300">{group.description}</p>
                <div className="mt-6 flex flex-wrap gap-3">
                  {group.skills.map((skill) => (
                    <span
                      key={skill}
                      className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-slate-200"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default SkillsSection;
